import { Card } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '../../../utils/helper';
import { useCurriculum } from '../hooks/useCurriculum';
import styles from './CurriculumStats.module.scss';

type CurriculumBaseStatsProps = {
  curriculumUuid: string | undefined;
};

export const CurriculumBaseStats = ({ curriculumUuid }: CurriculumBaseStatsProps) => {
  const { t } = useTranslation();

  const { tableData } = useCurriculum({ versionUuid: curriculumUuid ?? '' });

  const subjectHours = tableData.reduce((prev, curr) => prev + (curr.curriculumInfo?.studentCards ?? 0), 0);
  const studentHours = tableData.reduce((prev, curr) => prev + (curr.curriculumInfo?.studentHours ?? 0), 0);
  const deputat = tableData.reduce((prev, curr) => prev + (curr.curriculumInfo?.deputat ?? 0), 0);

  return (
    <Card wrapperClass={styles['curriculum-stats']} className={styles.content} fitContent contentPadding='none'>
      <div className={styles.stats}>
        <div className={styles.stat}>
          <div>{t('subjectHours.title', { count: 2 })}</div>
          <div>{formatNumber(subjectHours)}</div>
        </div>
        <div className={styles.stat}>
          <div>{t('subjectHours.studentHours')}</div>
          <div>{formatNumber(studentHours)}</div>
        </div>
        <div className={styles.stat}>
          <div>{t('deputate.title', { count: 1 })}</div>
          <div>{formatNumber(deputat)}</div>
        </div>
      </div>
    </Card>
  );
};
